import { useTranslation } from 'react-i18next'

import { QA_NAME_CONFIRMATION } from '../../../../constants/qa'
import { ConfirmationModal } from '../../../Confirmation'
import { copyEmailToEntity, deleteEmailCopiedEntity } from '../../Email.api'
import {
  EmailCopyToEntityModal,
  getEmailCopyToModalPayload,
  toEmailCopyToEntityApiData,
} from '../../EmailCopyToEntityModal'

import { getEmailParticipantsIds } from './useEmailCopyTo.utils'

export function useEmailCopyTo({
  copyToApi = copyEmailToEntity,
  deleteCopiedEntityApi = deleteEmailCopiedEntity,
  id,
  onCloseModal,
  onSetModal,
}) {
  const { t } = useTranslation()

  async function handleCopyEmailToEntity(data) {
    return copyToApi({ data, uuid: id }).then(response => {
      onCloseModal()

      return response
    })
  }

  async function handleDeleteCopiedEntity({
    getPreparedData = toEmailCopyToEntityApiData,
    id,
    name,
    uuid,
  }) {
    return deleteCopiedEntityApi({
      data: getPreparedData({ id, name }),
      uuid,
    }).then(response => {
      onCloseModal()

      return response
    })
  }

  function handleClickDeleteCopiedEntity({ onSubmit }) {
    onSetModal(
      <ConfirmationModal
        actionButtonsProps={{
          submitText: t('Modal.CommonRemoveBtnKey'),
        }}
        description={t('EmailProfile.CopiedToRemoveConfirmationModalTextKey')}
        qaName={QA_NAME_CONFIRMATION}
        onCancel={onCloseModal}
        onSubmit={onSubmit}
      />
    )
  }

  function handleOpenCopyToModal({ item, onSubmit }) {
    onSetModal(
      <EmailCopyToEntityModal
        getPayload={getEmailCopyToModalPayload}
        initialIds={getEmailParticipantsIds(item)}
        isPrivate={item?.is_private}
        onClose={onCloseModal}
        onSetModal={onSetModal}
        onSubmit={onSubmit}
      />
    )
  }

  return {
    handleClickDeleteCopiedEntity,
    handleCopyEmailToEntity,
    handleDeleteCopiedEntity,
    handleOpenCopyToModal,
  }
}
